import { MenuSection } from '../../menuSections/useMenuSections'

export const useSegmentedMenuSwitcher = (
  activeSectionChildren: MenuSection[],
  isSegmentedMenu: boolean,
  handleItemClick: (section: MenuSection) => void
) => {
  const isFirstSegmentedSectionSelected = isSegmentedMenu && activeSectionChildren?.[0]?.isSelected

  const activeSegmentedMenuTab = isSegmentedMenu
    ? activeSectionChildren?.find((s) => s.isSelected)
    : null

  const normalizeSegmentedMenuSection = (s: MenuSection) => ({
    ...s,
    name: s.label,
    onClick: () => handleItemClick(s),
  })

  const orderedSections = isFirstSegmentedSectionSelected
    ? activeSectionChildren ?? []
    : [...(activeSectionChildren ?? [])].reverse()

  const segmentedMenuSections = orderedSections.map(normalizeSegmentedMenuSection)

  return { activeSectionChildren, activeSegmentedMenuTab, segmentedMenuSections }
}
